"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var formik_1 = require("formik");

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var components_1 = require("../../components");

var enums_1 = require("../../enums");

var store_1 = require("../../store");

var validation_1 = require("../../validation");

var styled_1 = require("../styled");

var FormikConnected_1 = __importDefault(require("./FormikConnected"));

var PersonalDetailsInputs_1 = require("./PersonalDetailsInputs");

var TermsAndConditionsBox_1 = __importDefault(require("./TermsAndConditionsBox"));

var TITLES = ['How do you prefer to register?', 'Let’s know each other']; // todo create HOC - PhoneRegistrationFormComponent & EmailRegistrationFormComponent

var EmailRegistrationFormComponent =
/** @class */
function (_super) {
  __extends(EmailRegistrationFormComponent, _super);

  function EmailRegistrationFormComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.setPageTitle = function (activeStep) {
      var setPageTitle = _this.props.setPageTitle;
      var title = TITLES[activeStep];
      setPageTitle(title);
    };

    _this.validateEmail = function (props) {
      var validEmailCheck = _this.props.validEmailCheck;
      var errors = props.errors,
          setFieldTouched = props.setFieldTouched,
          setFieldValue = props.setFieldValue,
          setSubmitting = props.setSubmitting,
          currentEmail = props.values.email;
      var _a = _this.props.emailValidation,
          email = _a.email,
          emailAvailable = _a.emailAvailable,
          validated = _a.validated;
      setFieldTouched(enums_1.FieldNames.email);

      if (currentEmail && currentEmail !== email && !errors.email) {
        setSubmitting(true);
        validEmailCheck(currentEmail);
      } else if (currentEmail === email && validated) {
        setFieldValue(enums_1.FieldNames.emailValid, emailAvailable);
        setSubmitting(false);
      }
    };

    _this.onEmailChanged = function (props) {
      props.setFieldValue(enums_1.FieldNames.emailValid, true);
    };

    return _this;
  }

  EmailRegistrationFormComponent.prototype.componentDidMount = function () {
    this.setPageTitle(this.props.activeStep);
  };

  EmailRegistrationFormComponent.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.activeStep !== this.props.activeStep) {
      this.setPageTitle(this.props.activeStep);
    }
  };

  EmailRegistrationFormComponent.prototype.onEmailValidationStateChange = function (prevEmailValidation, nextEmailValidation, formikProps) {
    var setFieldValue = formikProps.setFieldValue,
        setSubmitting = formikProps.setSubmitting;
    var prevEmail = prevEmailValidation.email,
        prevValidatedEmailChecked = prevEmailValidation.validated;
    var nextEmail = nextEmailValidation.email,
        validatedEmailAvailable = nextEmailValidation.emailAvailable,
        validatedEmailChecked = nextEmailValidation.validated;

    if (prevEmail === nextEmail && validatedEmailChecked !== prevValidatedEmailChecked) {
      setFieldValue(enums_1.FieldNames.emailValid, validatedEmailAvailable);
      setSubmitting(false);
    } else if (prevEmail !== nextEmail) {
      setSubmitting(true);
    }
  };

  EmailRegistrationFormComponent.prototype.isContinueButtonDisabled = function (props) {
    var errors = props.errors,
        touched = props.touched;
    var _a = this.props.emailValidation,
        validated = _a.validated,
        emailAvailable = _a.emailAvailable;
    var emailCheckedAndAvailable = validated && emailAvailable;
    var signupCodeParamAvailable = false;
    var params = core_1.locationWebService.parseQueryParams(core_1.locationWebService.location.search);

    if (params && Object.keys(params).length > 0) {
      signupCodeParamAvailable = true;
    }

    if (signupCodeParamAvailable === true) {
      return !touched.email || !emailCheckedAndAvailable || !(props.touched.email && emailCheckedAndAvailable && !errors.email && !errors.emailConfirm && !errors.emailValid && !errors.password && !errors.passwordConfirm && !errors.termsAccepted && props.values.complianceTermsAccepted);
    }

    return !touched.email || !emailCheckedAndAvailable || !(props.touched.email && emailCheckedAndAvailable && !errors.email && !errors.emailConfirm && !errors.emailValid && !errors.password && !errors.passwordConfirm && !errors.termsAccepted);
  };

  EmailRegistrationFormComponent.prototype.setInitialAvatarValue = function (dirty, values) {
    var avatars = this.props.avatars;

    if (!dirty) {
      return avatars[0] ? avatars[0].id : '';
    }

    return values.avatar;
  };

  EmailRegistrationFormComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        previousHandler = _a.previousHandler,
        nextHandler = _a.nextHandler,
        activeStep = _a.activeStep,
        MaskedInputDate = _a.screenProps.components.MaskedInputDate,
        initialValues = _a.initialValues,
        navigation = _a.navigation,
        showTerms = _a.showTerms,
        showComplianceTerms = _a.showComplianceTerms,
        avatars = _a.avatars,
        activeBreakpoint = _a.activeBreakpoint,
        emailValidation = _a.emailValidation,
        updating = _a.updating,
        _onSubmit = _a.onSubmit;
    var email = emailValidation.email,
        validated = emailValidation.validated;
    var waitingForEmailValidation = !!email && !validated;
    return react_1.default.createElement(formik_1.Formik, {
      initialValues: initialValues,
      onSubmit: function onSubmit(values, _a) {
        var setSubmitting = _a.setSubmitting;
        setSubmitting(true);

        _onSubmit(values);
      },
      validationSchema: validation_1.registrationValidationSchema,
      render: function render(props) {
        var dirty = props.dirty,
            values = props.values;

        var avatarInitialSelection = _this.setInitialAvatarValue(dirty, values);

        return react_1.default.createElement(components_lib_1.Steps, {
          activeStep: activeStep
        }, react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(components_1.FormInputGroup, null, react_1.default.createElement(FormikConnected_1.default, {
          emailValidation: emailValidation,
          onEmailValidated: _this.onEmailValidationStateChange,
          formik: __assign({}, props)
        }), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.email,
          label: enums_1.FieldLabels.email,
          name: enums_1.FieldNames.email,
          onBlur: function onBlur() {
            _this.validateEmail(props);
          },
          onChangeText: function onChangeText() {
            _this.onEmailChanged(props);
          },
          linkedField: enums_1.FieldNames.emailValid,
          isLoading: waitingForEmailValidation,
          isDisabled: waitingForEmailValidation,
          accessibilityLabel: 'Enter your email'
        }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.emailConfirm,
          label: enums_1.FieldLabels.emailConfirm,
          name: enums_1.FieldNames.emailConfirm,
          isDisabled: waitingForEmailValidation,
          accessibilityLabel: 'Confirm your email'
        }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
          placeholder: enums_1.FieldPlaceHolders.password,
          name: enums_1.FieldNames.password,
          isSecure: true,
          allowPasswordReveal: true,
          isDisabled: waitingForEmailValidation,
          accessibilityLabel: 'Enter your password'
        }, props))), react_1.default.createElement(components_lib_1.ImagePickerContainer, {
          activeBreakpoint: activeBreakpoint,
          tabIndex: -1
        }, react_1.default.createElement(components_lib_1.StyledInputLabel, null, enums_1.FieldLabels.avatar), react_1.default.createElement(components_lib_1.ImagePickerWithForm, __assign({
          collection: avatars,
          initialSelectedId: avatarInitialSelection,
          name: enums_1.FieldNames.avatar
        }, props))), react_1.default.createElement(TermsAndConditionsBox_1.default, __assign({
          showTerms: showTerms,
          showComplianceTerms: showComplianceTerms
        }, props)), react_1.default.createElement(styled_1.AuthButtonsContainer, null, react_1.default.createElement(components_lib_1.RowWrapper, null, react_1.default.createElement(components_lib_1.Button, {
          type: components_lib_1.ButtonTypeEnum.primary,
          text: enums_1.FieldLabels.continue,
          onPress: nextHandler,
          uppercase: true,
          accessibilityLabel: enums_1.FieldLabels.continue,
          disabled: _this.isContinueButtonDisabled(props)
        })))), react_1.default.createElement(PersonalDetailsInputs_1.PersonalDetailsInputs, __assign({
          updating: updating,
          navigation: navigation,
          previousHandler: previousHandler,
          activeBreakpoint: activeBreakpoint,
          DateInputComponent: MaskedInputDate
        }, props)));
      }
    });
  };

  return EmailRegistrationFormComponent;
}(react_1.Component);

exports.EmailRegistrationFormComponent = EmailRegistrationFormComponent;

var mapStateToProps = function mapStateToProps(state) {
  // todo to top level component
  var emailValidation = store_1.emailValidationSelector(state);
  var updating = store_1.authUpdatingSelector(state);
  return {
    emailValidation: emailValidation,
    updating: updating
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    registerUser: redux_1.bindActionCreators(store_1.registerSubmitActionCreator, dispatch),
    validEmailCheck: redux_1.bindActionCreators(store_1.validEmailCheckActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var hoc = redux_1.compose(connector);
exports.default = hoc(EmailRegistrationFormComponent);